import React from 'react';
import { Button, Text, Box, Collapse, Flex } from '@televet/kibble-ui';

interface IBottomCollapsibleBox {
  onCancel: () => void;
  hasChanges: boolean;
  isLoading: boolean;
  isDisabled?: boolean;
  onSave: () => void;
}
const CollapsibleFooter = ({
  onCancel,
  hasChanges,
  onSave,
  isLoading,
  isDisabled,
}: IBottomCollapsibleBox): JSX.Element => {
  return (
    <Box w="100%" boxShadow="0 -1px 3px 0 rgb(0 0 0 / 10%), 0 -1px 2px 0 rgb(0 0 0 / 6%)">
      <Collapse style={{ width: '100%' }} in={hasChanges}>
        <Flex w="100%" p="12px 20px" justify="flex-end" bgColor="background.default">
          <Flex gap={3} align="center">
            <Text>Unsaved changes</Text>
            <Button width={92} variant="tertiary" onClick={onCancel}>
              Cancel
            </Button>
            <Button width={92} onClick={onSave} isDisabled={isDisabled} isLoading={isLoading}>
              Save
            </Button>
          </Flex>
        </Flex>
      </Collapse>
    </Box>
  );
};

export default CollapsibleFooter;
